import { render, staticRenderFns } from "./btraextra.vue?vue&type=template&id=101fccc2"
import script from "./btraextra.vue?vue&type=script&lang=js"
export * from "./btraextra.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports